Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    datePickerInputValueLetterSpacing: 2,
    datePickerInputPlaceholderFontSize: 13,
    datePickerInputPlaceholderLineHeight: "18px",
    datePickerInputPlaceholderColorDefault: tokens.themeInkSubdued,
    datePickerInputPlaceholderColorDisabled: tokens.themeInkDisabled,
    datePickerInputSpacingHorizontal: 8,
    datePickerPopoverElevation: 70,
    datePickerPopoverBackgroundColor: tokens.themeSurfaceDefault,
    datePickerPopoverBorderWidth: 1,
    datePickerPopoverBorderRadius: 4,
    datePickerPopoverBorderColor: tokens.themeBorderFormfield,
    datePickerPopoverDropShadowOffsetX: 0,
    datePickerPopoverDropShadowOffsetY: 1,
    datePickerPopoverDropShadowBlur: 2,
    datePickerPopoverDropShadowSpread: 0,
    datePickerPopoverDropShadowColor: "#02080E",
    datePickerPopoverDropShadowOpacity: 16,
    datePickerPopoverSpacingInset: 32,
    datePickerPopoverSpacingVertical: 8,
    datePickerErrorTooltipElevation: 80,
    datePickerPresetsDividerWidth: 1,
    datePickerPresetsDividerColor: tokens.themeBorderDefault
  }
};